///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class SectorConstants {
    public static readonly SECTOR_WIDTH_ANGLE = 90;
    public static readonly SECTOR_ARC_STEP = 0.5;

    public static readonly NOT_ACTIVE_LAYER_FILL_OPACITY = 0.05;
    public static readonly NOT_ACTIVE_LAYER_STROKE_OPACITY = 0.3;

    public static readonly SECTOR_DEFAULT_COLOR = '#88c8e2';
    public static readonly SECTOR_SELECTED_COLOR = '#49e260';
    public static readonly SECTOR_58320_COLOR = '#e97a19';
    public static readonly SECTOR_60480_COLOR = '#4481e2';
    public static readonly SECTOR_62640_COLOR = '#e9d819';
    public static readonly SECTOR_64800_COLOR = '#ab44e2';

    public static readonly SECTOR_FORCED_COLOR = '#693dff';

    public static readonly SECTOR_BOM_ACTIVE_COLOR = '#00FF00';
}
